import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import React, { useMemo } from 'react'
import { useController } from 'react-hook-form'
import { styles } from './styles'

const STATES = {
  ACTIVE: 'Shown',
  INACTIVE: 'Hidden',
}

export default function StateDropdown({ control }) {
  const {
    field: { onChange, ref, value, ...dropdownProps },
  } = useController({
    name: 'state',
    control,
    defaultValue: 'ACTIVE',
  })

  const overlay = useMemo(() => {
    return (
      <React.Fragment>
        {Object.keys(STATES).map(id => (
          <Dropdown.Menu.Item key={id} itemKey={id}>
            {STATES[id]}
          </Dropdown.Menu.Item>
        ))}
      </React.Fragment>
    )
  }, [])

  return (
    <Dropdown {...dropdownProps} onSelect={onChange} overlay={overlay}>
      <Dropdown.Button css={styles.fullWidth} htmlType="button" ref={ref}>
        {STATES[value]}
      </Dropdown.Button>
    </Dropdown>
  )
}
